import { css } from '@emotion/react';

export const Strong = ({ children }) => {
	return (
		<strong
			css={css`
				font-weight: 600;
			`}
		>
			{children}
		</strong>
	);
};
